import React from 'react'
import styles from './styles.module.css'

const SubTitulo = ({children}) => {
    return (
        <h2 className={styles.SubTitulo}>{children}</h2>
    )
}

export default SubTitulo